const isEnUs = (str) => {
	if (!str) return false;
	const normalized = str.toLowerCase().replace("_", "-");
	return normalized === "en-us";
};

export {
	isEnUs
};
